export const brandCurrencyPrefixes = {
  AMTRAK: '$',
  AVAU: '$',
  AVUK: '£',
  AVCA: '$',
  AVNZ: '$',
  RAILBOOKER: '£',
  RBCA: '$',
  RBAU: '$',
  RBUS: '$',
  RBNZ: '$',
}

export const brandCurrencySuffixes = {
  AVAU: 'AUD',
  AVCA: 'CAD',
  AVNZ: 'NZD',
  RBCA: 'CAD',
  RBAU: 'AUD',
  RBNZ: 'NZD',
}

export const clientIds = {
  AMTRAK: 'amtrak',
  AVAU: 'avau',
  AVUK: 'avuk',
  AVCA: 'avca',
  AVNZ: 'avnz',
  RAILBOOKER: 'railbookers',
  RBCA: 'rbca',
  RBAU: 'rbau',
  RBNZ: 'rbnz',
  RBUS: 'rbus',
}

export const parentBrands = {
  amtrak: 'AMTRAK',
  railbooker: 'RAILBOOKER',
};

export function isRailBookers() {
  return process.env.REACT_APP_PARENT_BRAND_CODE === parentBrands.railbooker;
}

